import { Box, Button, Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../features/track';
import { ContentCardProps } from '../data';

export const AccountLevelBanner: React.FC<ContentCardProps> = ({
  description,
  linkText,
  dismissible,
  url,
  handleDismissal,
  handleCardClick,
  trackingModule: eventModule,
  trackingFlow: eventFlow,
  extras: { name: eventName, linkTarget },
}) => {
  return (
    <Box
      data-testid="accountLevelBanner"
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        py: 'space.200',
        px: 'space.300',
        mt: 'space.200',
        bg: 'background.info',
      }}
    >
      <Box css={{ mr: 'space.100' }}>
        {description && <Text color="text" dangerouslySetInnerHTML={{ __html: description }} />}
        {url && linkText && (
          <>
            {' '}
            <SambaAutoLink
              to={url}
              target={linkTarget}
              rel="noopener noreferrer"
              onClick={event => {
                trackClick({ name: `${eventName}_${linkText}`, module: eventModule, flow: eventFlow });
                handleCardClick(event);
              }}
              data-testid="contentCardLink"
            >
              {linkText}
            </SambaAutoLink>
          </>
        )}
      </Box>
      {dismissible && (
        <Button
          aria-label="Dismiss card"
          onClick={handleDismissal}
          variant="ghostSecondary"
          spacing="compact"
          css={{ padding: 0 }}
        >
          <Icon name="X" size="small" color="icon.accent.navy" />
        </Button>
      )}
    </Box>
  );
};
